import React from "react";
import { useLoaderData, useNavigation } from "react-router-dom";
import { API } from '@aws-amplify/api';
import InvitationList from "../Invitations/invitationlist";
import UserInfoForm from "../Forms/userinfoform";

export default function Invite({props}) {
  console.log('props into invites default function', {props});
  //const invitations = JSON.parse(props);
  const props_parsed = JSON.parse(props)

  var invitations = props_parsed.invites;
  
  console.log('invites invites invitations',invitations);
  //var invites = ucs.invites;
  const navigation = useNavigation();
  //var var2 = ucs;  
  //console.log('var 2 obj-->',var2,"<---") 
  //console.log('var 2-->',JSON.stringify(var2),"<---") 

  function handleDelete(id) {    
    console.log('would delete ',id);
    const newInvites = invitations.filter(invites => invites.invitee_email.S !== id)
    invitations = newInvites;
    console.log('would delete', id);
    const apiName = 'apic48d2c9b' // 'api4df5e677' // was 'api60cb0321';
    const path = "/invite" ;
    const myInit = {
      body: id,
      headers: {'Content-Type':'application/json'}, 
        response: true
    };
    API.del(apiName, path, myInit)
      .then((response) => {        
        return response.data;
      })
      .catch((error) => {
        console.log(error.response);
      });
      return invitations;
  }


  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };


  function insertInvite() {
    console.log('starting the insert');
    var emailList = document.getElementById('email_list');
    var post_body = {"emailList":[emailList.value]}
    console.log(emailList.value);
    var cleaned = emailList.value.replace(/\s/g,'')
    var email_list = cleaned.split(",");
    var len_list = email_list.length;
    console.log('lenis', len_list);

    console.log('using post_body',post_body);    
    const apiName = 'apic48d2c9b' // 'api60cb0321';
    const path = '/invite';
    const myInit = {
      body: post_body, // replace this with attributes you need
      headers: {} // OPTIONAL
    };
    API.post(apiName, path, myInit)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error.response)
    })
  }
  

  if (navigation.state === "loading") {
    return <h1>Loading the current invitations...</h1>
  }
  return (
    <>
    <div style={{ padding: 10 }}>
   {invitations && <InvitationList invitations={invitations} handleDelete={handleDelete}/>}  
  </div>
  </>
  ) ;
}
